import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const UpdateCustomer = () => {
  const { updatecustomerid } = useParams()
  const [customerData, setCustomerData] = useState({
    name: '',
    email: '',
    title: 'SELECT',
    guardian_title: 'SELECT',
    guardian_name: '',
    phone_number: '',
    city: '',
    state: 'SELECT',
    pincode: '',
    address: '',
    id_type: 'SELECT',
    id_number: '',
  })
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  // Fetch customer data when component mounts
  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      setError('Authentication required. Please log in.')
      return
    }

    setLoading(true)
    axios
      .get(BASE_URL+`/customers/${updatecustomerid}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log('Fetched customer data:', response.data.data)
        setCustomerData(response.data.data) // Set fetched data to form
        setLoading(false)
      })
      .catch((err) => {
        console.error('Error fetching customer data:', err)
        setError('Failed to fetch customer data.')
        setLoading(false)
      })
  }, [updatecustomerid])

  // Handle form input changes
  const inputHandler = (e) => {
    const { name, value } = e.target
    setCustomerData({ ...customerData, [name]: value })
    // setCustomerData((prevData) => ({ ...prevData, [name]: value }))
    console.log(`Updated ${name}:`, value)
  }

  // Handle form submission for updating customer
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    const token = Cookies.get('authToken') // Ensure the token is still valid
    if (!token) {
      setError('Authentication required. Please log in.')
      return
    }

    // Payload including the customerData ID and name
    const payload = {
      ...customerData, // Your updated customerData data (including name)
      id: updatecustomerid, // Pass the customer ID as part of the data
    }
    console.log('Payload being sent:', payload)

    axios
      .post(
        // Change to POST method
        BASE_URL+'/customer/update', // Correct API endpoint
        payload, // Send customer data including the ID
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include the authorization token
          },
        },
      )
      .then((response) => {
        console.log('customer updated successfully:', response.data)

        setShowModal(true) // Show success modal
        setTimeout(() => {
          navigate('/customerlists')
          window.location.reload()
        }, 3000)
      })
      .catch((err) => {
        if (err.response) {
          console.error('Error response:', err.response.data)
          setError(
            `Failed to update customer: ${
              err.response.data.message || 'Unknown error'
            }`,
          )
        } else {
          console.error('Error:', err.message)
          setError('Failed to update customer.')
        }
      })
  }
  const handleModalClose = () => {
    setShowModal(false)
  }

  return (
    <Container className="pb-3" style={{fontFamily: theme.font.family }}>

      <Form className="text-start rounded-3 m-0 px-3" onSubmit={handleSubmit} style={{backgroundColor: theme.colors.background}}> 

          <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
          Update Customer
            
          </p>


        <Row>
          <Col md={2} className="mb-3 ">
            <Form.Label htmlFor="title">Title</Form.Label>
            <Form.Select
              id="title"
              name="title"
              value={customerData.title}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              <option value="Mr">Mr.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Dr">Dr.</option>
            </Form.Select>
          </Col>
          <Col md={4} className="mb-3 ">
            <Form.Label htmlFor="name">Name</Form.Label>
            <Form.Control
              type="text"
              id="name"
              name="name"
              value={customerData.name}
              onChange={inputHandler}
            />
          </Col>
          <Col md={2} className="mb-3 ">
            <Form.Label htmlFor="guardian_title">Guardian Title</Form.Label>
            <Form.Select
              id="guardian_title"
              name="guardian_title"
              value={customerData.guardian_title}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              <option value="Mr">Mr.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Dr">Dr.</option>
            </Form.Select>
          </Col>
          <Col md={4} className="mb-3 ">
            <Form.Label htmlFor="guardian_name">Guardian Name</Form.Label>
            <Form.Control
              type="text"
              id="guardian_name"
              name="guardian_name"
              value={customerData.guardian_name}
              onChange={inputHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3 ">
            <Form.Label htmlFor="email">Email</Form.Label>
            <Form.Control
              type="email"
              id="email"
              name="email"
              value={customerData.email}
              onChange={inputHandler}
            />
          </Col>
          <Col md={6} className="mb-3 ">
            <Form.Label htmlFor="phone_number">Phone Number</Form.Label>
            <Form.Control
              type="text"
              id="phone_number"
              name="phone_number"
              value={customerData.phone_number}
              // placeholder={customerData.phone_number || 'Enter phone number'}
              onChange={inputHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-3 ">
            <Form.Label htmlFor="state">State</Form.Label>
            <Form.Select
              id="state"
              name="state"
              value={customerData.state}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              <option value="DELHI">DELHI</option>
              <option value="UTTAR PRADESH">UTTAR PRADESH</option>
              <option value="BIHAR">BIHAR</option>
            </Form.Select>
          </Col>

          <Col md={4} className="mb-3 ">
            <Form.Label htmlFor="city">City</Form.Label>
            <Form.Control
              type="text"
              id="city"
              name="city"
              value={customerData.city}
              onChange={inputHandler}
            />
          </Col>

          <Col md={4} className="mb-3 ">
            <Form.Label htmlFor="pincode">Pincode</Form.Label>
            <Form.Control
              type="text"
              id="pincode"
              name="pincode"
              value={customerData.pincode}
              onChange={inputHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-3 ">
            <Form.Label htmlFor="address">Address</Form.Label>
            <Form.Control
              as="textarea"
              id="address"
              name="address"
              value={customerData.address}
              onChange={inputHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3 text-start">
            <Form.Label htmlFor="id_type">ID Type</Form.Label>
            <Form.Select
              id="id_type"
              name="id_type"
              value={customerData.id_type}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              <option value="AADHAR CARD">AADHAR CARD</option>
              <option value="PAN CARD">PAN CARD</option>
              <option value="LICENSE">DRIVING LICENCE</option>
            </Form.Select>
          </Col>
          <Col md={6} className="mb-3 text-start">
            <Form.Label htmlFor="id_number">ID Number</Form.Label>
            <Form.Control
              type="text"
              id="id_number"
              name="id_number"
              value={customerData.id_number}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        {error && <div className="alert alert-danger">{error}</div>}
        <div className="d-grid mt-4 ">
          <Button
            type="submit"
            className="text-white"
            style={{ backgroundColor: theme.colors.primary, border: 'none' }}
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Customer'}
          </Button>
        </div>
      </Form>

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            Customer Updated Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You can now view their details or proceed with the next steps in the
            process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default UpdateCustomer
